"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDashboardStatsResponseSchema = exports.getDashboardStatsQuerySchema = exports.getDashboardResponseSchema = exports.getDashboardStatsParamsSchema = exports.getDashboardParamsSchema = void 0;
const zod_1 = require("zod");
const common_schemas_1 = require("../base/common.schemas");
const api_schemas_1 = require("../base/api.schemas");
// ============================================
// MERCHANT DASHBOARD SCHEMAS
// ============================================
// Common merchant params schema
const _MerchantParamsSchema = zod_1.z.object({
    merchantId: zod_1.z.coerce.number().int().positive(),
});
// GET /merchants/:merchantId/dashboard - Params
exports.getDashboardParamsSchema = _MerchantParamsSchema;
// GET /merchants/:merchantId/dashboard/stats - Params
exports.getDashboardStatsParamsSchema = _MerchantParamsSchema;
// GET /merchants/:merchantId/dashboard - Response
// Quick overview cards (FR section: Dashboard)
exports.getDashboardResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    member_count: zod_1.z.number().int().min(0),
    active_coupon_count: zod_1.z.number().int().min(0),
    today_redemptions: zod_1.z.number().int().min(0),
    today_revenue: common_schemas_1.moneyAmountSchema,
}));
// GET /merchants/:merchantId/dashboard/stats - Query
exports.getDashboardStatsQuerySchema = zod_1.z.object({
    period: zod_1.z.enum(['7d', '30d', '90d']).default('30d'),
});
// GET /merchants/:merchantId/dashboard/stats - Response
exports.getDashboardStatsResponseSchema = (0, api_schemas_1.dataResponseSchema)(zod_1.z.object({
    redemptions_over_time: zod_1.z.array(zod_1.z.object({
        date: zod_1.z.string(),
        count: zod_1.z.number().int(),
        revenue: common_schemas_1.moneyAmountSchema,
    })),
    top_coupons: zod_1.z.array(zod_1.z.object({
        coupon_id: zod_1.z.number().int(),
        title: zod_1.z.string(),
        redemptions: zod_1.z.number().int(),
    })),
}));
